/* global FB */
import React from "react";
import { createRoot } from "react-dom/client";
import { Amplify } from "aws-amplify";
import config from "./config";
import App from "./App";
import store from "./Redux/store";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";

// Load Facebook SDK asynchronously
(function (d, s, id) {
  const fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;

  const js = d.createElement(s);
  js.id = id;
  js.src = "https://connect.facebook.net/en_US/sdk.js";
  js.async = true;
  js.defer = true;

  js.onload = () => {
    // Initialize Facebook SDK after it's loaded
    if (window.FB) {
      window.FB.init({
        appId: "260610716065473", // Replace with your Facebook App ID
        autoLogAppEvents: true,
        xfbml: true,
        version: "v12.0",
      });
    }
  };

  fjs.parentNode.insertBefore(js, fjs);
})(document, "script", "facebook-jssdk");

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
    oauth: {
      scope: ["aws.cognito.signin.user.admin", "email"],
    },
  },
  Storage: {
    region: config.s3.REGION,
    bucket: config.s3.BUCKET,
  },
  API: {
    endpoints: [
      {
        name: "libra-ecommerce",
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
    ],
  },
});

// Render React App
const root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </Provider>
);
